// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemParseExtended } from '../../../assets/icons/extended/entities/gem-parse.svg?react';
import { createIcons } from '../../Icon';
const GemParseIcon = /* @__PURE__ */ createIcons('GemParse', {
    extended: GemParseExtended
});
GemParseIcon.supportedTypes = ['extended'];
GemParseIcon.category = 'entities';
export default GemParseIcon;
